import type { PanBounds, Size } from "web_myplann/Chat/Types/pinchZoom";

export const getPanBounds = (
	container: Size,
	content: Size,
	scale: number,
): PanBounds => ({
	maxX: Math.max(0, (content.width * scale - container.width) / 2),
	maxY: Math.max(0, (content.height * scale - container.height) / 2),
});
